export const allCourses=[
    {
        No:1,
        CourseCode:'CPT211',
        CourseTitle:'Object-Oriented Programming I',
        Unit:3,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:2,
        CourseCode:'CPT213',
        CourseTitle:'Computer Organization and Assembly Language',
        Unit:2,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:3,
        CourseCode:'CPT214',
        CourseTitle:'Computer Architecture',
        Unit:3,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:4,
        CourseCode:'CSS216',
        CourseTitle:'Cryptography Theory 1',
        Unit:3,
        Semester:'1ST',
        Nature:'elective',
    },
    {
        No:5,
        CourseCode:'GST211',
        CourseTitle:'Logic and Philosophy',
        Unit:2,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:6,
        CourseCode:'MAT212',
        CourseTitle:'Linear Algebra I',
        Unit:2,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:7,
        CourseCode:'MAT216',
        CourseTitle:'Mathematical Methods I',
        Unit:3,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:8,
        CourseCode:'STA217',
        CourseTitle:'Probability II',
        Unit:3,
        Semester:'1ST',
        Nature:'core',
    },
    {
        No:9,
        CourseCode:'PHY216',
        CourseTitle:'Electric Circuits and Electronics',
        Unit:3,
        Semester:'1ST',
        Nature:'elective',
    },
    {
        No:10,
        CourseCode:'CIT224',
        CourseTitle:'Discrete Mathematical Structure',
        Unit:3,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:11,
        CourseCode:'CPT221',
        CourseTitle:'Object-Oriented Programming II',
        Unit:2,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:12,
        CourseCode:'CPT222',
        CourseTitle:'Data Structures',
        Unit:3,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:13,
        CourseCode:'CPT223',
        CourseTitle:'Introduction to Algorithms',
        Unit:3,
        Semester:'2ND',
        Nature:'elective',
    },
    {
        No:14,
        CourseCode:'CPT224',
        CourseTitle:'Introduction to Web Design',
        Unit:2,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:15,
        CourseCode:'CPT226',
        CourseTitle:'Hardware Systems and Maintenance',
        Unit:1,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:16,
        CourseCode:'MAT222',
        CourseTitle:'Linear Algebra II',
        Unit:2,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:17,
        CourseCode:'MAT225',
        CourseTitle:'Introduction to Numerical Analysis',
        Unit:3,
        Semester:'2ND',
        Nature:'core',
    },
    {
        No:18,
        CourseCode:'CSS226',
        CourseTitle:'Cryptography Theory 2',
        Unit:3,
        Semester:'2ND',
        Nature:'elective',
    },
]